import '.b8{flex-shrink:0;}.ssr-plugin'
import '.w{padding:1rem;}.ssr-plugin'
import '.a8{width:100%;}.ssr-plugin'
import '.br{height:100%;}.ssr-plugin'
import '.bh{border:none;}.ssr-plugin'
import '.bi{background-color:transparent;}.ssr-plugin'
import '.c2{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ag{align-items:stretch;}.ssr-plugin'
import '.bu{position:sticky;}.ssr-plugin'
import '.c3{top:4rem;}.ssr-plugin'
import '.c4{z-index:7;}.ssr-plugin'
import '.aj{background-color:var(--shades-white);}.ssr-plugin'
import '.c5{padding-bottom:1rem;}.ssr-plugin'
import '.y{margin-bottom:1rem;}.ssr-plugin'
import '.c6{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a2{position:fixed;}.ssr-plugin'
import '.bv{top:0px;}.ssr-plugin'
import '.bp{left:0px;}.ssr-plugin'
import '.bq{right:0px;}.ssr-plugin'
import '.c7{bottom:0px;}.ssr-plugin'
import '.c8{z-index:9999;}.ssr-plugin'
import '.c9{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.ca{justify-content:flex-end;}.ssr-plugin'
import '.cb{flex:1;}.ssr-plugin'
import '.bd{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="b8 w a8 br bh bi c2"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a e ag"
    >
      <div className="bu c3 c4 aj c5 y c6 a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a2 bv bp bq c7 c8 aj c9 a e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="w a ca c6"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="cb bd">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
